import { eventPlace, onlineLabel } from "../../helpers/calendar";
import { colors } from "../../style";
import { Icon } from "../ui";

// Online meetings blue, in person green, like Sidekick desktop
export const eventColor = (e) => (e.is_online ? colors.call : colors.green);

export const eventTitle = (e) => e.subject || "Untitled event";

export const isDeclined = (e) => e.my_response === "declined";

// "Teams" and/or "Room 2", each with its icon
export function WhereLabel({ event, size = 12 }) {
  const online = onlineLabel(event);
  const place = eventPlace(event);
  const item = {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    minWidth: 0,
  };
  return (
    <>
      {online && (
        <span style={item}>
          <Icon name="video" size={size} />
          {online}
        </span>
      )}
      {place && (
        <span style={item}>
          <Icon name="mapPin" size={size} />
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {place}
          </span>
        </span>
      )}
    </>
  );
}
